import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

import { useFetchPricelistPrices } from "../api/react-query/queries/pricelist-show";

function getOverlapAmount(el1: HTMLDivElement, r2: DOMRect) {
    const r1 = el1.getBoundingClientRect();
    const overlapX = Math.max(0, Math.min(r1.right, r2.right) - Math.max(r1.left, r2.left));
    const overlapY = Math.max(0, Math.min(r1.bottom, r2.bottom) - Math.max(r1.top, r2.top));
    const overlapArea = overlapX * overlapY;

    return {
        overlapX,
        overlapY,
        overlapArea,
    };
}

export const ShrinkingLogoSecondary = () => {
    const { shopId, screenId } = useParams();
    const { data: pricesData } = useFetchPricelistPrices(shopId, screenId);
    const [scale, setScale] = useState(1);
    const [initialLogoRect, setInitialLogoRect] = useState<DOMRect | null>(null);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [translateY, setTranslateY] = useState(0);

    useEffect(() => {
        if (imageLoaded) {
            const logo = document.querySelector(".logoSecondary") as HTMLDivElement;
            const rect = logo.getBoundingClientRect();
            setInitialLogoRect(rect);
        }
    }, [imageLoaded]);

    useEffect(() => {
        if (!initialLogoRect) return;
        const timer = setTimeout(() => {
            const fullCategories = document.querySelectorAll<HTMLDivElement>(".marginTopTitle");
            const lastCategory = fullCategories[fullCategories.length - 1];

            if (!lastCategory) return;

            const { overlapY } = getOverlapAmount(lastCategory, initialLogoRect);
            const h = initialLogoRect.height;

            const safeOverlap = Math.min(Math.max(overlapY, 0), h);
            const calculatedScale = (h - safeOverlap) / h;

            const adjustedTranslateY = safeOverlap * calculatedScale;

            setTranslateY(adjustedTranslateY);
            setScale(calculatedScale);
        }, 0);

        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pricesData]);

    return (
        <div>
            <img
                style={{
                    transition: "transform 0.15s ease-out",
                    transform: `
                        translateY(${translateY}px)
                        scale(${scale})
                    `,
                    display: scale < 0.3 ? "none" : "block",
                }}
                className={`logoSecondary`}
                src="/images/pricelist/deSteegLogoTransparent.png"
                alt="secondary logo"
                onLoad={() => setImageLoaded(true)}
            />
        </div>
    );
};
